<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-12-03 09:03:06
 * @LastEditTime : 2025-04-08 15:08:14
 * @LastEditors  : yangxr
 * @Description  : 合并工程弹窗
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\engBind.vue
-->
<template>
    <div>
        <el-dialog :visible.sync="visible" width="680px" :close-on-click-modal="false" @open="open">
            <span slot="title" class="dialog-title">合并工程</span>
            <div class="bill_top">
                <span style="color:red">该主工程已绑定以下相同财务编码子工程</span>
            </div>
            <div class="dialoginfo">
                <el-table ref="engTable" :header-cell-style="{ background: '#f3f6f9' }" border stripe :data="engTableData"
                    tooltip-effect="dark" @selection-change="selectEng">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="engineeringName" label="工程名称" width="auto">
                    </el-table-column>
                    <el-table-column label="结算周期" width="180">
                        <template slot-scope="scope">
                            {{ scope.row.lastDueTime }}-{{ scope.row.currentDueTime }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button class="bottom_all_two" @click="reset">取 消</el-button> -->
                <el-button class="bottom_all_two" @click="reset">关 闭</el-button>
                <el-button v-if="!isLook" class="bottom_all" @click="confirm">确 认</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { queryEngCycleList } from "@/api/wise/settlementTask.js";
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        isLook: {
            type: Boolean,
            default: false,
        },
        engBindMainId: {},
        childCycles: [],
    },
    data() {
        return {
            tableParams: {
                page: 1,
                pageSize: 10,
                code: "",
                name: "",
                status: 1,//只查询启用状态
            },
            engTableData: [],
        }
    },
    watch: {
    },
    methods: {
        open() {
            queryEngCycleList({ id: this.engBindMainId }).then(res => {
                this.engTableData = res.data;
                // 清空当前选中的行
                this.$refs.engTable.clearSelection();
                // 遍历 id 数组，选中对应的行
                setTimeout(() => {
                this.childCycles.forEach(cycle => {
                    const row = this.engTableData.find(item => item.id == cycle.childCycleId);
                    console.log(row)
                    if (row) {
                        this.$refs.engTable.toggleRowSelection(row, true); // 选中对应的行
                    }
                });
            }, 10);
            });
        },
        submitDept() {
            if (this.currentRow.length == 0) {
                this.$message.warning("请选中一条数据");
                return;
            }
            this.reset()
        },
        selectEng(val) {
            this.selectEngInfo = JSON.parse(JSON.stringify(val))
        },
        reset() {
            this.$emit("resetEngBind");
        },
        confirm() {
            let childCycles = this.selectEngInfo.map(item => {
                return {
                    childCycleId: item.id,//子工程任务id
                    engineeringId: item.engineeringId,//子工程id
                    engineeringName: item.engineeringName,//子工程名称
                    lastDueTime: item.lastDueTime,//子工程任务日期
                    currentDueTime: item.currentDueTime//日期
                }
            })
            console.log(childCycles)
            this.$emit('changeBindEng', childCycles)
        },
    }
}
</script>
<style lang="scss" scoped>
.addClass {
    display: flex;
    justify-content: end;
    margin-bottom: 15px;
}

.mr15 {
    margin-right: 15px;
}

.table_link {
    margin-left: 10px;
    color: $bg_color;
}

.table_link:hover {
    opacity: 0.8;
}

.table_link--disabled {
    color: #00b85c;
    /* 灰色表示禁用 */
    cursor: not-allowed;
    /* 禁用光标 */
    pointer-events: none;
    /* 禁用点击事件 */
    text-decoration: none;
    /* 去掉下划线 */
}

::v-deep .el-table__body tr.current-row>td {
    color: #fff;
    background: #00b85c !important;
}
</style>